<template>
  <div>   
    <h1 class="zero clipper"><a @click="showViewModal = true">{{item.name}}</a></h1>
    <h6 class="zero c6 clipper">{{item.descriptor}}</h6>

    <ez-modal v-if="showViewModal" @close="showViewModal = false" size="m-large">
      <detail :item="item"></detail>
    </ez-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import modal from "@/mixins/vue-ez-modal";
import Detail from "@/components/character/_Detail";

export default {
  name: "character-sheet-name",
  mixins: [modal],
  components: {
    Detail
  },
  data() {
    return {
      showViewModal: false
    };
  },
  computed: {
    ...mapGetters({
      item: "characters/getEntity"
    })
  }
};
</script>

<style lang="scss" scoped>
.zero {
  margin: 0;
}
h6 {
  margin-bottom: 0.5em !important;
}
</style>
